import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider, useDispatch } from 'react-redux';
import store from './store/configureStore';
import App from './App';
import { authAction } from './features/auth/slice';
import axios from 'axios';
import './index.css';
import ReactGa from 'react-ga4';

ReactGa.initialize('G-N8S8P0FB6X', { debug_mode: true });

// 사용자 정보를 불러와주는 컴포넌트
const Root = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;

    const loadMe = async () => {
      dispatch(authAction.setLoading(true));
      try {
        const res = await axios.get('/auth/me', {
          headers: { Authorization: `Bearer ${token}` },
        });
        dispatch(authAction.changeMe(res.data));
      } catch (e) {
        dispatch(authAction.changeMe(null));
        localStorage.removeItem('token');
      } finally {
        dispatch(authAction.setLoading(false));
      }
    };

    loadMe();
  }, [dispatch]);

  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Root />
  </Provider>
);
